// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  lookId: __t.u64().primaryKey().name("look_id"),
  battleId: __t.u64().name("battle_id"),
  worldId: __t.u64().name("world_id"),
  versonaId: __t.u64().name("versona_id"),
  archetype: __t.string(),
  civ: __t.string(),
  name: __t.string(),
});
